

// import React, { useState } from "react";
// import axios from "axios";
// import { Navigate, useNavigate } from "react-router-dom";
// import logo from '../img/logo.png'
// import {
//   MDBContainer,
//   MDBRow,
//   MDBCol,
//   MDBCard,
//   MDBCardBody,
//   MDBInput,
// } from "mdb-react-ui-kit";

// const AdminLogin = ({ condition }) => {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [userType, setUserType] = useState("Admin"); // Default to Admin
//   const [errMsg, setErrMsg] = useState("");



// const handleLogin=async()=>{

//   await axios.post('https://320eapi.emedha.in/auth/api/admin',{
//     email,
//     password
//   }).then((resp)=>{
//     if (resp.data.success) {
//       alert("Login Successful!");
//       sessionStorage.setItem('email',  email)
//       condition(sessionStorage.getItem('email'))
//     }else{
//       alert(resp.data.message)
//     }
//   })
// }

//   return (
//     <div>
//       <br /><br /><br /><br />
//       <MDBContainer fluid>
//         <MDBRow className="d-flex justify-content-center align-items-center h-100">
//           <MDBCol col="12">
//             <MDBCard
//               className="bg-warning text-white my-2 mx-auto"
//               style={{ borderRadius: "1rem", maxWidth: "400px" }}
//             >
//               <MDBCardBody className="p-5 d-flex flex-column align-items-center mx-auto w-100">
//                 <h2 className="fw-bold mb-4 text-uppercase">
//                   <img
//                     src={logo}
//                     height="100px"
//                     width="100px"
//                     className="logo1"
//                     alt="Logo"
//                   />
//                 </h2>
//                 <h2 className="mb-2 text-uppercase">Login</h2>

             

//                 <MDBInput
//                   wrapperClass="mb-4 mx-5 w-100"
//                   labelClass="text-white"
//                   placeholder="Email"
//                   id="formControlLg"
//                   type="text"
//                   size="lg"
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//                 <MDBInput
//                   wrapperClass="mb-4 mx-5 w-100"
//                   labelClass="text-white"
//                   placeholder="Password"
//                   id="formControlLg"
//                   type="password"
//                   size="lg"
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
            
                 
//                 <button className="btn btn-danger mx-5 px-5" onClick={handleLogin}>
//                   Login
//                 </button>
//               </MDBCardBody>
//             </MDBCard>
//           </MDBCol>
//         </MDBRow>
//       </MDBContainer>
//     </div>
//   );
// };

// export default AdminLogin;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import logo from '../img/logo.png';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
} from "mdb-react-ui-kit";

const AdminLogin = ({ condition }) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dist, setDist] = useState(""); // ✅ District selection
  const [errMsg, setErrMsg] = useState("");



const handleLogin = async () => {
  try {
    const resp = await axios.post("https://lionsdirectoryapi.emedha.in/auth/api/admin", {
      email,
      password,
      dist
    });

    if (resp.data.success) {
      alert("Login Successful!");

      sessionStorage.setItem("email", email);
      sessionStorage.setItem("id", resp.data.id);
      sessionStorage.setItem("dist", resp.data.dist || ""); // blank for superAdmin
      sessionStorage.setItem("role", resp.data.role); // superAdmin / admin / user

     if (condition) condition();
        navigate("/");
    } else {
      alert(resp.data.message);
    }
  } catch (err) {
    console.error("Login Error:", err);
    alert("An error occurred. Please try again.");
  }
};

const [districts, setDistricts] = useState([]);

const fetchDistricts = async () => {
  try {
    const res = await axios.get("https://lionsdirectoryapi.emedha.in/auth/api/api/districts");
    setDistricts(res.data);
  } catch (error) {
    console.error("Error fetching districts:", error);
  }
};


useEffect(() => {
  fetchDistricts();
}, []);


  return (
    <div>
      <br /><br /><br /><br />
      <MDBContainer fluid>
        <MDBRow className="d-flex justify-content-center align-items-center h-100">
          <MDBCol col="12">
            <MDBCard
              className="bg-warning text-white my-2 mx-auto"
              style={{ borderRadius: "1rem", maxWidth: "400px" }}
            >
              <MDBCardBody className="p-5 d-flex flex-column align-items-center mx-auto w-100">
                <h2 className="fw-bold mb-4 text-uppercase">
                  <img
                    src={logo}
                    height="100px"
                    width="100px"
                    className="logo1"
                    alt="Logo"
                  />
                </h2>
                <h2 className="mb-2 text-uppercase">Login</h2>

                <MDBInput
                  wrapperClass="mb-4 mx-5 w-100"
                  placeholder="Email"
                  type="text"
                  size="lg"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <MDBInput
                  wrapperClass="mb-4 mx-5 w-100"
                  placeholder="Password"
                  type="password"
                  size="lg"
                  onChange={(e) => setPassword(e.target.value)}
                />

                {/* ✅ District Dropdown */}
 <select
  className="form-select mb-4 mx-5 w-100"
  value={dist}
  onChange={(e) => setDist(e.target.value)}
>
  <option value="">Select District</option>
  <option value="Super Admin">Super Admin</option>

  {districts.map((d) => (
    <option key={d.id} value={d.name}>
      {d.name}
    </option>
  ))}
</select>

                <button className="btn btn-danger mx-5 px-5" onClick={handleLogin}>
                  Login
                </button>
                <p className="mt-3 text-light">
  Don't have an account?{" "}
  <Link to="/admin-signup">
    <strong style={{color:'navy-blue'}}>Create one</strong>
  </Link>
</p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default AdminLogin;
